import { Box, Button, Grid, IconButton, TextField } from '@mui/material'
import React from 'react'
import {
    useDeleteOrganizerMutation,
    useGetOrganizersQuery,
} from '../../../../generated/graphql'
import Loading from '../../../loading'
import DeleteIcon from '@mui/icons-material/Delete'
import EditIcon from '@mui/icons-material/Edit'
import { useNavigate } from 'react-router-dom'
import CustomDataGrid from '../../../customDataGrid'

const OrganizersTable = () => {
    const navigate = useNavigate()
    const [deleting, setDeleteting] = React.useState<string[]>([])

    const [search, setSearch] = React.useState('')

    const [deleteOrganizer, { loading: loadingDelete }] =
        useDeleteOrganizerMutation()

    const { data, loading } = useGetOrganizersQuery()

    const handleDelete = React.useCallback(
        (id: string | undefined) => {
            if (!id) return
            setDeleteting([...deleting, id])
            deleteOrganizer({
                variables: {
                    data: {
                        id,
                    },
                },
                onCompleted: () => {
                    setDeleteting(deleting.filter((d) => d !== id))
                },
                refetchQueries: ['getOrganizers', 'getPeople'],
            })
        },
        [deleteOrganizer, deleting, setDeleteting]
    )

    const organizers = React.useMemo(() => {
        return data?.organizers || []
    }, [data])

    const columns = React.useMemo(
        () => [
            { field: 'id', headerName: 'ID', flex: 1 },
            { field: 'name', headerName: 'Name', flex: 1 },
            { field: 'email', headerName: 'Email', flex: 1 },
            { field: 'phone', headerName: 'Phone', flex: 1 },
            { field: 'dni', headerName: 'DNI', flex: 1 },
            { field: 'conditions', headerName: 'Conditions', flex: 1 },
            {
                field: 'actions',
                headerName: 'Actions',
                width: 120,
                renderCell: ({ row }: { row: any }) => (
                    <Grid
                        display={'flex'}
                        justifyContent={'center'}
                        alignItems={'center'}
                        sx={{ width: '100%', height: '100%' }}
                    >
                        <IconButton
                            onClick={() => navigate(`update/${row.id}`)}
                        >
                            <EditIcon />
                        </IconButton>
                        {loadingDelete && deleting.includes(row.id || '') ? (
                            <Box
                                sx={{ marginLeft: '8px', marginRight: '8px' }}
                                display={'flex'}
                                alignItems={'center'}
                            >
                                <Loading size={'1.6em'} />
                            </Box>
                        ) : (
                            <IconButton onClick={() => handleDelete(row.id)}>
                                <DeleteIcon />
                            </IconButton>
                        )}
                    </Grid>
                ),
            },
        ],
        [handleDelete, navigate, deleting, loadingDelete]
    )

    const rows = React.useMemo(() => {
        const searched = search
            ? organizers.filter(
                  (o) =>
                      (o.fullName?.toLocaleLowerCase() || '').includes(
                          search
                      ) ||
                      (o.email?.toLocaleLowerCase() || '').includes(search) ||
                      (o.phone || '').includes(search) ||
                      (o.surname?.toLocaleLowerCase() || '').includes(search) ||
                      (o.dni || '').includes(search)
              )
            : organizers
        return searched.map((organizer) => {
            return {
                id: organizer.id,
                name: organizer.fullName,
                email: organizer.email,
                phone: organizer.phone,
                dni: organizer.dni,
                conditions: `${organizer.organizer?.conditions}%`,
            }
        })
    }, [organizers, search])

    return loading ? (
        <Loading />
    ) : (
        <>
            <Grid
                display={'flex'}
                alignItems={'center'}
                sx={{ marginBottom: 2 }}
            >
                <TextField
                    label="Search"
                    variant="outlined"
                    size={'small'}
                    fullWidth
                    onChange={(e) =>
                        setSearch((e.target.value || '').toLowerCase())
                    }
                />
                <Button variant="contained" sx={{ marginLeft: 2 }}>
                    seach
                </Button>
            </Grid>
            <CustomDataGrid
                rows={rows}
                columns={columns}
                loading={loading}
                density="compact"
            />
        </>
    )
}

export default React.memo(OrganizersTable)
